import { useConnect } from '@lore/query-connect';
import REQUIRED_FIELDS_PUBLIC from '../offers/REQUIRED_FIELDS_PUBLIC';

export default function useActiveOffersForUser(user, options = {}) {
  return useConnect('offer.find', {
    where: {
      eager: {
        $where: {
          creatorId: user.id,
          $and: REQUIRED_FIELDS_PUBLIC.$and
        }
      }
    },
    pagination: {
        page: options.page || 1,
        pageSize: options.pageSize || 3,
        order: 'createdAt desc'
      }
    });
  }
